<template>
  <div class="step step--products step-products">
    <div class="step-products__container">
      <div class="step-products__title" v-html="$t('products.title')"></div>

      <ul class="step-products__products">
        <li class="step-products__product">
          <a target="_self" href="https://www.daikin.com.ua/uk_ua/product-group/air-to-air-heat-pumps/stylish.html?utm_source=Special_project_Mars&utm_medium=information_stands&utm_content=month&utm_term=Stylish&utm_campaign=Daikin_Jun-Aug_2021"> <img src="@/assets/img/products/stylish.png" class="image-rendering-contrast-disabled" alt="stylish">
          </a>
        </li>

        <li class="step-products__product">
          <a target="_self" href="https://www.daikin.com.ua/uk_ua/products/ftxf-c.html?utm_source=Special_project_Mars&utm_medium=information_stands&utm_content=month&utm_term=Sensira&utm_campaign=Daikin_Jun-Aug_2021"> <img src="@/assets/img/products/sensira.png" class="image-rendering-contrast-disabled" alt="sensira">
          </a>
        </li>

        <li class="step-products__product">
          <a target="_self" href="https://www.daikin.com.ua/uk_ua/product-group/air-to-air-heat-pumps/ururu-sarara.html?utm_source=Special_project_Mars&utm_medium=information_stands&utm_content=month&utm_term=Ururu_Sarara&utm_campaign=Daikin_Jun-Aug_2021"><img src="@/assets/img/products/ururu.png" class="image-rendering-contrast-disabled" alt="ururu"></a>
        </li>

        <li class="step-products__product">
          <a target="_self" href="https://www.daikin.com.ua/uk_ua/solutions/for-your-home/air-purification.html?utm_source=Special_project_Mars&utm_medium=information_stands&utm_content=month&utm_term=Air_purifiers&utm_campaign=Daikin_Jun-Aug_2021"><img src="@/assets/img/products/MCK55W.png" class="image-rendering-contrast-disabled" alt="MCK55W"></a>
        </li>
      </ul>
      <div class="step-products__button-wrapper">
        <Button classes="step-products__button button--dark-small" @click="goToBeginning" v-html="$t('products.button')"></Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/global/Button'

export default {
  name: 'StepProducts',

  components: {
    Button
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  methods: {
    goToBeginning() {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-go-to-start',
          'analytics_label': this.$store.state.step,
        })
      }

      window.location.reload()
    }
  }
}
</script>

<style scoped>

</style>
